<template>
    <el-container style="height: 100%; border: 1px solid #eee;overflow:hidden;" >
        <el-header style="height: 50px; padding: 0px">
                <TopHeader></TopHeader>
            </el-header>
        <el-container style="text-align: left; font-size: 12px;overflow:hidden">
            <el-aside  :width="widthFlag ? '64px':'210px'" style="background-color: #505458">
            <LeftAside v-on:widthFlag="showFlagFromChild"></LeftAside>
            </el-aside>
            <el-main class="page_scroll" style="overflow:auto">
                <!-- 增加返回顶部按钮 需要注意这里和el-main 的class要对应 -->
                <el-backtop target=".page_scroll" :bottom="100" :visibility-height="50"></el-backtop>
                <router-view/>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import LeftAside from "@/components/common/LeftAside";
    import TopHeader from "@/components/common/TopHeader";
    export default {
        name: "Index",
    data() {
        return {
            widthFlag:false
            }
        },
        components: {
            LeftAside,
            TopHeader
        },
        methods:{
            showFlagFromChild(data){
                    this.widthFlag=data;
                    console.log(data);
            }
        }
    }
</script>

<style scoped>

</style>
